const languageContainer = require('./language-container');
const spellcheckerStorage = require('./spellchecker-storage');

const LANGUAGE_MAPPING = {
    "English": "en-Us",
    "Supers": "en-Us"
};

class Spellchecker {
    constructor() {

    }

    async getMisspelledWordsOccurrences(rawCaptions) {
        let misspelledWordsToCaptions = {};
        if (!this.isSuportted()) {
            return misspelledWordsToCaptions;
        }
        let currentLanguageName = languageContainer.get().value;
        let text = rawCaptions.reduce((text, rawCaption) => text += rawCaption.row1 + " " + rawCaption.row2 + " ", "");
        let requestUrl = "http://localhost:3002/" + LANGUAGE_MAPPING[currentLanguageName] + "/check?text=" + text;
        let tuples = await $.get(requestUrl);
      
        let misspelledWords = tuples.map(tuple => tuple.word);
        let captionIndex = 0;
        let wordIndex = 0;
        
        while (wordIndex < misspelledWords.length) {
            let misspelledWord = misspelledWords[wordIndex];
            let currentCaption = rawCaptions[captionIndex];
            let repetitions = this._getNumOfWordRepetitionsInCaption(currentCaption, misspelledWord);
            if (repetitions > 0) {
                if (!spellcheckerStorage.isIgnored(misspelledWord, currentCaption.id)) {
                    if (misspelledWordsToCaptions[misspelledWord] == null) {
                        misspelledWordsToCaptions[misspelledWord] = [];
                    }
                    if (misspelledWordsToCaptions[misspelledWord].indexOf(currentCaption) == -1) {
                        misspelledWordsToCaptions[misspelledWord].push(currentCaption);
                    }
                }
                wordIndex += repetitions;
            } else {
                captionIndex++;
            }
        }

        return misspelledWordsToCaptions;
    }

    isSuportted(language) {
        // Cancel the support of spellchecker - it doesn't work and throws an error
        return false;
        let currentLanguageName = languageContainer.get().value;
        return LANGUAGE_MAPPING[currentLanguageName] != null;
    }

    ignore(word, captionId) {
        spellcheckerStorage.ignore(word, captionId);
    }

    ignoreAll(word) {
        spellcheckerStorage.ignoreAll(word);
    }

    filterIgnored(misspelledWordsToCaptions) {
        let misspelledWords = Object.keys(misspelledWordsToCaptions);
        for (var i = 0; i < misspelledWords.length; i++) {
            let misspelledWord = misspelledWords[i];
            for (var j = misspelledWordsToCaptions[misspelledWord].length - 1; j >=0; j--) {
                let relatedCaption = misspelledWordsToCaptions[misspelledWord][j];
                if (spellcheckerStorage.isIgnored(misspelledWord, relatedCaption.id)) {
                    //if tuple of (word,captionId) is ignored than remove it from dictionary
                    misspelledWordsToCaptions[misspelledWord].splice(j, 1);
                }
            }

            if (misspelledWordsToCaptions[misspelledWord].length == 0) {
                delete misspelledWordsToCaptions[misspelledWord];
            }
        } 

        return misspelledWordsToCaptions;
    }

    _getNumOfWordRepetitionsInCaption(rawCaption, wordToFind) {
        let captionText = rawCaption.row1 + " " + rawCaption.row2;
        let captionWords = captionText.split(" ");
        return captionWords.reduce((accumulator, word) => {
            let result = wordToFind == word ? 1 : 0;
            return accumulator + result;
        }, 0);
    }


}

module.exports = new Spellchecker();


// WEBPACK FOOTER //
// ./app/helpers/spellchecker.js